import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import api from '../../api/api'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { SETTING_CONFIG } from './config.'
import Swal from 'sweetalert2'
import RequireField from '../../component/RequireField'

export default function Groups() {
    const [dataItemCatalogs, setDataItemCatalogs] = useState([])
    const [dataItemGroups, setDataItemGroups] = useState([])
    const [dataItemTypes, setDataItemTypes] = useState([])
    const [nameItemCatalogs, setNameItemCatalogs] = useState('')
    const [nameItemGroups, setNameItemGroups] = useState('')
    const [nameItemTypes, setNameItemTypes] = useState('')
    const [data, setData] = useState()
    const [noError, setNoError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [open, setOpen] = useState(false);
    const [No, setNo] = useState('');
    const [Name, setName] = useState('');
    const [Description, setDescription] = useState('');
    const [Status, setStatus] = useState('Y');
    const [openType, setOpenType] = useState(false);
    const [validBranchNo, setValidBranchNo] = useState(false)
    const [validBranchNoText, setValidBranchNoText] = useState('')
    const Open = (x, type) => {
        if (type === 'C') {
            setNo(x?.CatalogNo)
            setName(x?.CatalogName)
        }
        if (type === 'G') {
            setNo(x?.GroupNo)
            setName(x?.GroupName)
        }
        if (type === 'T') {
            setNo(x?.TypeNo)
            setName(x?.TypeName)
        }
        setData(x)
        setOpenType(type)
        setDescription(x?.Description)
        setStatus(x?.Status || 'Y')
        setOpen(true)
    }
    const Close = () => {
        setOpenType()
        setData()
        setOpen(false)
        setName('')
        setNo('')
        setDescription('')
        setStatus('Y')
        setNameError(false)
        setNoError(false)
        setValidBranchNo(false)
        setValidBranchNoText('')
    }


    const getItemCatalogs = async () => {
        const res = await api.get(`dbms/itemcatalogs?name=${nameItemCatalogs}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemCatalogs(data)
        }
    }
    const getItemGroups = async () => {
        const res = await api.get(`dbms/itemgroups?name=${nameItemGroups}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemGroups(data)
        }
    }

    const getItemTypes = async () => {
        const res = await api.get(`dbms/itemtypes?name=${nameItemTypes}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDataItemTypes(data)
        }
    }
    useEffect(() => {
        getItemCatalogs()

    }, [nameItemCatalogs])
    useEffect(() => {
        getItemGroups()
    }, [nameItemGroups])
    useEffect(() => {
        getItemTypes()
    }, [nameItemTypes])

    const handleSubmit = () => {
        if (!No) {
            setNoError(true)
        }
        if (!Name) {
            setNameError(true)
        }
        if (No && Name) {
            if (openType === 'C') {
                const body = {
                    CatalogId: data?.CatalogId || null,
                    CatalogNo: No,
                    CatalogName: Name,
                    Description: Description,
                    Status: Status
                }
                const addCatalog = async () => {
                    if (data?.CatalogId) {
                        const url = SETTING_CONFIG.requests.getGroupCatalogy.url + `/${body?.CatalogNo}`;
                        const res = await api.put(url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemCatalogs()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }
                    } else {

                        const res = await api.post(SETTING_CONFIG.requests.getGroupCatalogy.url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemCatalogs()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }

                    }
                }
                addCatalog()
            }
            if (openType === 'G') {
                const body = {
                    GroupId: data?.GroupId || null,
                    GroupNo: No,
                    GroupName: Name,
                    Description: Description,
                    Status: Status
                }
                const groupAdd = async () => {
                    if (data?.GroupId) {
                        const url = SETTING_CONFIG.requests.getGroups.url + `/${body?.GroupNo}`;
                        const res = await api.put(url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemGroups()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }
                    } else {

                        const res = await api.post(SETTING_CONFIG.requests.getGroups.url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemGroups()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }

                    }
                }
                groupAdd()
            }
            if (openType === 'T') {
                const body = {
                    TypeId: data?.TypeId || null,
                    TypeNo: No,
                    TypeName: Name,
                    Description: Description,
                    Status: Status
                }
                const itemTypeAdd = async () => {
                    if (data?.TypeId) {
                        const url = SETTING_CONFIG.requests.getItemTypes.url + `/${body?.TypeNo}`;
                        const res = await api.put(url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemTypes()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }
                    } else {

                        const res = await api.post(SETTING_CONFIG.requests.getItemTypes.url, body)
                        const data = res.data
                        if (data.status === true) {
                            Close()
                            getItemTypes()
                            Swal.fire(
                                'ทำรายการสำเร็จ',
                                '',
                                'success'
                            )
                        } else {
                            Swal.fire({
                                title: data?.message || 'ทำรายการไม่สำเร็จ',
                                icon: 'warning',
                            })
                        }

                    }
                }
                itemTypeAdd()
            }
        }
    }

    async function validateGroupsNo(No) {
        if (!No) {
            setValidBranchNo(true)
            setValidBranchNoText('กรุณากรอกรหัสศูนย์')
        }
        if (No.length === 1) {
            setValidBranchNo(true)
            setValidBranchNoText('กรุณากรอกรหัสให้ครบ 2 หลัก')
        }
        if (No.length === 2) {
            const url = openType === 'G' ? `dbms/itemgroups/${No}` : openType === 'C' ? `dbms/itemcatalogs/${No}`: `dbms/itemtypes/${No}`;
            const res = await api.get(url)
            const checkStatus = res.data.result
            if (data && (No === data?.BranchNo)) {
                setValidBranchNo(false)
            } else {
                setValidBranchNo(true)
                setValidBranchNoText(checkStatus ? 'มีรหัสนี้อยู่ในระบบแล้ว' : '')
            }
        }
    }

    return (
        <Page>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4 col-sm-12">
                        <label class="title-content mb-4">
                            ประเภทข้าว
                        </label>

                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <label class="title-content mb-4">
                            พันธุ์ข้าว
                        </label>

                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <label class="title-content mb-4">
                            ชนิดข้าว
                        </label>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="d-flex justify-content-between align-items-center ">
                            <div class="">
                                <input value={nameItemGroups} onChange={e => setNameItemGroups(e.target.value)} class="form-control" type="text" placeholder="ค้นหา ประเภทข้าว" />
                            </div>
                            <div class="group-add cp" style={{ cursor: 'pointer' }} onClick={() => Open(null, 'G')} >
                                เพิ่มประเภทข้าว
                            </div>


                        </div>

                        <div class="menu-list table-responsive-sm mt-3">
                            {dataItemGroups?.map((x, i) => (
                                <div class="menu menu-row" onClick={() => Open(x, 'G')}>
                                    <div class="menu">
                                        {x?.GroupName}
                                    </div>

                                    <div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 ">
                        <div class="d-flex justify-content-between align-items-center ">
                            <div class="">
                                <input value={nameItemCatalogs} onChange={e => setNameItemCatalogs(e.target.value)} class="form-control" type="text" placeholder="ค้นหา พันธุ์ข้าว" />
                            </div>
                            <div class="group-add cp" style={{ cursor: 'pointer' }} onClick={() => Open(null, 'C')}>
                                เพิ่มพันธุ์ข้าว
                            </div>


                        </div>

                        <div class="menu-list table-responsive-sm mt-3">
                            {dataItemCatalogs?.map((x, i) => (
                                <div class="menu menu-row" onClick={() => Open(x, 'C')}>

                                    <div class="menu">
                                        {x?.CatalogName}
                                    </div>

                                    <div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div >

                    <div class="col-12 col-lg-4 ">
                        <div class="d-flex justify-content-between align-items-center ">
                            <div class="">
                                <input value={nameItemTypes} onChange={e => setNameItemTypes(e.target.value)} class="form-control" type="text" placeholder="ค้นหา ชนิดข้าว" />
                            </div>
                            <div class="group-add cp" style={{ cursor: 'pointer' }} onClick={() => Open(null, 'T')}>
                                เพิ่มชนิดข้าว
                            </div>


                        </div>

                        <div class="menu-list table-responsive-sm mt-3">
                            {dataItemTypes?.map((x, i) => (
                                <div class="menu menu-row" onClick={() => Open(x, 'T')}>

                                    <div class="menu">

                                        {x?.TypeName}
                                    </div>

                                    <div>
                                    </div>
                                </div>
                            ))}

                        </div >
                    </div >
                </div >
            </div >
            <Dialog
                open={open}
            >
                <DialogTitle id="alert-dialog-title">
                    {openType === 'C' ? data ? 'แก้ไขพันธุ์ข้าว' : 'เพิ่มพันธุ์ข้าว' : openType === 'G' ? data ? 'แก้ไขประเภทข้าว' : 'เพิ่มประเภทข้าว' : data ? 'แก้ไขชนิดข้าว' : 'เพิ่มชนิดข้าว'}
                </DialogTitle>
                <DialogContent>
                    <div class="row" style={{ marginBottom: '10px' }}>
                        <div class="col-lg-6 col-md-12">
                            <label class="labelInput">{openType === 'G' ? 'รหัสประเภท' : openType === 'C' ? 'รหัสพันธุ์' : 'รหัสชนิดข้าว'}</label>
                            <Box className={`backgroundField ${noError ? 'error' : ''}`} >
                                <TextField value={No} onChange={e => {
                                    setNo(e.target.value)
                                    validateGroupsNo(e.target.value)

                                }} variant="standard" fullWidth
                                    onBlur={e => {
                                        if (!e.target.value) {
                                            setNoError(true)
                                        } else {
                                            setNoError(false)
                                        }
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                    inputProps={{ maxLength: 13 }}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    disabled={data ? true : false}

                                />
                            </Box>
                            {noError && <span style={{ color: 'red', fontSize: '12px', }}>{openType === 'G' ? 'กรุณากรอกรหัสประเภท' : openType === 'C' ? 'กรุณากรอกรหัสพันธุ์' : 'กรุณากรอกรหัสพันธุ์'}</span>}
                            {validBranchNo && <span style={{ color: 'red', fontSize: '12px', }}>{validBranchNoText}</span>}

                        </div>
                        <div class="col-lg-6 col-md-12">
                            <label class="labelInput">{openType === 'G' ? 'ชื่อประเภท' : openType === 'C' ? 'ชื่อพันธุ์' : 'ชื่อชนิดข้าว'}</label>
                            <RequireField value={Name} onChange={setName} type={'text'} error={nameError} setError={setNameError} textError={openType === 'G' ? 'กรุณากรอกชื่อประเภท' : openType === 'C' ? 'กรุณากรอกชื่อพันธุ์' : 'กรุณากรอกชื่อพันธุ์'} />

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <label class="labelInput">คำอธิบาย</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField multiline rows={4} value={Description || ''} onChange={e => setDescription(e.target.value)} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <RadioGroup row value={Status || ''} onChange={e => setStatus(e.target.value)}>
                            <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                            <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                        </RadioGroup>

                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' sx={{ width: '120px' }} onClick={Close}>ปิด</Button>
                    <Button variant='contained' sx={{ width: '120px' }} onClick={handleSubmit} >
                        บันทึก
                    </Button>
                </DialogActions>
            </Dialog>
        </Page >
    )
}
